import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HelpPopoverComponent } from '@nk/ui-lib';
import { FRAUD_RISK_SCORE_RANGES, FRAUD_RISK_SCORE_TRANSLATIONS } from '../../utils/fraud-risk-score.utils';

@Component({
  selector: 'nk-fraud-risk-score-help-info',
  imports: [TranslateModule, HelpPopoverComponent],
  templateUrl: './fraud-risk-score-help-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FraudRiskScoreHelpInfoComponent {
  public fraudRiskScoreRanges = FRAUD_RISK_SCORE_RANGES;
  public fraudRiskScoreTranslations = FRAUD_RISK_SCORE_TRANSLATIONS;
}
